<template>
  <v-app id="inspire">
    <v-navigation-drawer app width="225" color="primary" class="pl-2" style="padding-top: 25px">
      <v-img max-width="205" src="@/assets/logo.png"></v-img>
      <v-list>
        <v-list-item-group mandatory>
          <div v-for="(menu, i) in menu" :key="i">
            <v-list-item
              v-if="!menu.subLinks"
              style="margin-top: 15px"
              link
              :to="{ name: menu.name }"              
              :key="i"
              active-class="black"
            >
              <v-list-item-icon>
                <v-icon color="white" v-text="menu.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text" v-text="menu.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group v-else >
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-icon class="white--text" v-text="menu.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="white--text" v-text="menu.text"></v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(subLink, j) in menu.subLinks"
                :key="j"
                style="margin-top: 15px; margin-left: 15px;"
                link
                :to="{ name: subLink.name }"  
              >                  
                <v-list-item-content>
                  <v-list-item-title class="white--text" v-text="subLink.text"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon color="white" v-text="subLink.icon"></v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-group>
          </div>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="white">mdi-exit-to-app</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text" @click="logout">Cerrar sesión </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>    

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>


<script>


import adminUserService from '@/services/admin/users';
import adminMonthlyService from '@/services/admin/monthlyPayments';

export default {
  components: {
  
  },
  computed: {
    user() {
      return this.$store.getters['session/user'];
    },
    getInitials() {
      var names = this.user.usernameLogin.split(' '),
        initials = names[0].substring(0, 1).toUpperCase();

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      return initials;
    },

    imageDefaul() {
      return require('@/assets/images/avatar_dz.jpg');
    },
    
  },
  data: () => ({
    scheduleSelected: null,
    income: [],
    monthly: [],
    selectedItem: 1,
    loading: false,
    menu: [
      { text: 'Dashboard', icon: 'mdi-view-grid', name: 'dashboardAdmin' },
      { text: 'Usuarios', icon: 'mdi-account', name: 'users',
        subLinks : [
              { text: 'Socios', icon: 'mdi-account', name: 'users' },
              { text: 'Depositos', icon: 'mdi-bank-transfer-in', name: 'deposits' },
              { text: 'Boletines', icon: 'mdi-newspaper', name: 'newsletter' },
              { text: 'Reservaciones', icon: 'mdi-calendar-today', name: 'booking' },
              { text: 'Notificaciones', icon: 'mdi-send', name: 'notifications' },
              { text: 'Tickets', icon: 'mdi-ticket', name: 'tickets' },
              { text: 'Reportes', icon: 'mdi-printer', name: 'userreportform' },
          ]
      },
      { text: 'Reglamentos', icon: 'mdi-file-sign', name: 'rules' },   
      { text: 'Ingresos', icon: 'mdi-cash-multiple', name: 'income' },            
      { text: 'Egresos', icon: 'mdi-cash-plus', name: 'spend' },       
      { text: 'Configuraciones', icon: 'mdi-wrench', name: 'settings' },
      { text: 'Reporte Cuotas', icon: 'mdi-grid', name: 'reports' },      
    ],
  }),
  created() {
    this.getUsers();
  },
  methods: {
    logout() {
      this.$store.dispatch('session/logout');
    },
    getUserInfo(userId) {
      if (!this.users) {
        return '';
      }
      const user = this.users.filter((item) => item.id === userId)[0];
      return user.usernameLogin;
    },
    getUserAvatar(userId) {
      if (!this.users) {
        return '';
      }
      const user = this.users.filter((item) => item.id === userId)[0];
      if (!user) return null;
      return user.imageUrl;
    },
    getUsers() {
      adminUserService.getUsers('all').then((response) => {
        this.users = response.data;
        this.fetchMonthly();
      });
    },
    usernameLogin(user) {
      return `${user.usernameLogin} [${user.email}]`;
    },
    fetchMonthly() {
      const startDate = this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD');
      const endDate = this.$dayjs().format('YYYY-MM-DD');

      this.loading = true;
      adminMonthlyService
        .search(null, 'paid', startDate, endDate)
        .then((response) => {
          this.monthly = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>